import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoaderComponent } from '@elan/components/loader-component/loader-component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('elan-frontend');

  ngOnInit(): void {
    this.checkVersionAndClearCache();
  }

  private checkVersionAndClearCache(): void {
    const currentVersion = environment.version;
    
    if (typeof localStorage !== 'undefined') {
      const storedVersion = localStorage.getItem('appVersion');

      if (storedVersion && storedVersion !== currentVersion) {
        localStorage.setItem('appVersion', currentVersion);
        this.clearCache();
      } else {
        localStorage.setItem('appVersion', currentVersion);
      }
    }
  }

  private clearCache(): void {
    if (typeof window !== 'undefined' && 'caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => registration.unregister());
      });
    }
    
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  }
}
